
  <div class="menu-desktop">
    <div class="select">{{ 'ULTIMATEGUIDE.LIBRARY' | translate }}</div>
    <ng-container *ngFor="let group of groups$ | async">
      <div (click)="toggleGroupActive(group)">
        <div class="table-head"
          ><i
            class="fas"
            [ngClass]="{
              'fa-angle-down': getActive(group),
              'fa-angle-right': !getActive(group)
            }"
          ></i
          >{{ group.title }}</div
        >
      </div>
      <div [@slideInOut]="getActive(group) ? 'in' : 'out'">
        <!-- <a class="table-route" [routerLink]="group.route">อันนี้กลุ่มนะ {{ group.title }} active:{{ group.active }}</a> -->
        <a class="table-route {{ page.active }}" *ngFor="let page of group.routes" [routerLink]="page.route"
          >{{ page.title }}</a
        >
      </div>
    </ng-container>
  </div>

  <div class="menu-ipad">
    <!-- test local -->
    <div class="select" *ngIf="false" (click)="openDetail($event, 'iosdev')">
    <div class="show-list">
      <div class="select-all">{{ 'ULTIMATEGUIDE.LIBRARY' | translate }} LOCAL</div>
      <i class="select-dropdown fas" [ngClass]="{
                    'fa-angle-up': animationState.iosdev === 'in',
                    'fa-angle-down': animationState.iosdev === 'out'
                  }"></i>
    </div>

      <div [@slideInOut]="animationState.iosdev">
        <ng-container>
          <div class="table-head">เอกสารขาย</div>
          <div>
            <a class="table-route active" [routerLink]="[]">helloooo</a>
            <a class="table-route" [routerLink]="[]">helloooo</a>
            <a class="table-route" [routerLink]="[]">helloooo</a>
          </div>
        </ng-container>
      </div>
    </div>
    
    <!-- end of test local -->


    <div class="select" (click)="openDetail($event, 'iosdev')">
      <div class="show-list">
        <div class="select-all">{{ 'ULTIMATEGUIDE.LIBRARY' | translate }}</div>
        <i class="select-dropdown fas" [ngClass]="{
                        'fa-angle-up': animationState.iosdev === 'in',
                        'fa-angle-down': animationState.iosdev === 'out'
                      }"></i>
      </div>

      <div [@slideInOut]="animationState.iosdev">
        <ng-container *ngFor="let group of groups$ | async">
          <div class="table-head">{{ group.title }}</div>
          <div>
            <a class="table-route {{ page.active }}" *ngFor="let page of group.routes"
              [routerLink]="page.route">{{ page.title }}</a>
          </div>
        </ng-container>
      </div>
    </div>
    


  </div>

